import { DocumentParser, ParsedDocument, ScanContext } from '../core/types';
import { cinFields, parseCinQr } from './cin/jwt';

/**
 * Brazilian CIN (Carteira de Identidade Nacional), shared via gov.br. The QR is
 * a signed JWT (ES512); claims carry the data, the rest sits behind the `url`.
 */
export class CinParser implements DocumentParser {
  readonly id = 'br-cin';
  readonly label = 'CIN (national ID)';

  detect(ctx: ScanContext): boolean {
    const s = ctx.symbols[0];
    if (!s) return false;
    const parts = s.text.split('.');
    // Cheap JWT shape check; full validation happens in parse().
    return parts.length === 3 && parts[0].startsWith('ey');
  }

  parse(ctx: ScanContext): ParsedDocument {
    const cin = parseCinQr(ctx.symbols[0].text)!;
    return {
      kind: 'cin',
      title: cin.isCin ? 'CIN (gov.br)' : 'JWT',
      country: 'BR',
      parser: this.id,
      fields: cinFields(cin).map((f) => ({ label: f.label, value: f.value })),
      signature: {
        algorithm: cin.signatureAlgorithm,
        hex: cin.signatureHex,
        status: 'unverified',
        detail: 'Verifiable with the MJSP public key (ES512).',
        // Bytes that were signed: ASCII of `header.payload`.
        signedData: new TextEncoder().encode(cin.signingInput),
      },
      raw: cin,
    };
  }
}
